import { render, staticRenderFns } from "./EssayExam.vue?vue&type=template&id=e2bb4aca&scoped=true&"
import script from "./EssayExam.vue?vue&type=script&lang=js&"
export * from "./EssayExam.vue?vue&type=script&lang=js&"
import style0 from "./EssayExam.vue?vue&type=style&index=0&id=e2bb4aca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2bb4aca",
  null
  
)

export default component.exports